import { formatMoney } from './../../helpers/formatMoney';

const maxLength = (max, value) =>
  value && value.length > max ? `El campo puede tener un máximo de ${max} caracteres` : undefined;

const minLength = (min, value) =>
  value && value.length < min ? `El campo debe tener un mínimo de ${min} caracteres` : undefined;

const maxLengthContadordes = (max, value) =>
  value && value.length > max ? `El contador no puede tener más de ${max} caracteres` : undefined;

const maxLengthContadorurl = (max, value) =>
  value && value.length > max ? `La URL no puede tener más de ${max} caracteres.` : undefined;

const maxLengthContadorbton = (max, value) =>
  value && value.length > max ? `El texto del botón no puede tener más de ${max} caracteres.` : undefined;

const maxLengthContadorforma = (max, value) =>
  value && value.length > max ? `El formato del contador no puede tener más de ${max} caracteres` : undefined;

function esPNGValido(file) {
  return new Promise((resolve) => {
    const reader = new FileReader();
  
    reader.onloadend = function () {
      const arrayBuffer = reader.result;
      const header = new Uint8Array(arrayBuffer.slice(0, 8));
  
        // Verifica los primeros bytes según la firma hexadecimal de un archivo PNG
      const signature = Array.from(header).map(byte => byte.toString(16).padStart(2, '0')).join('');
      const esValido = signature === '89504e470d0a1a0a';
  
        // Resuelve la promesa con el resultado de la validación
      resolve(esValido);
    };
  
      // Lee los primeros 8 bytes del archivo
    const blob = file.slice(0, 8);
    reader.readAsArrayBuffer(blob);
  });
}

class Validators {
  static requiredContador = value => (value ? undefined : 'Contador regresivo es requerido');
  static requiredTextBt= value => (value ? undefined : 'Texto botón es requerido');
  static requiredurl= value => (value ? undefined : 'URL es requerido');
  static requiredFI= value => (value ? undefined : 'Fecha y hora de inicio es requerido');
  static requiredFIN= value => (value ? undefined : 'Fecha y hora fin es requerido');
  static requiredFIN= value => (value ? undefined : 'Fecha y hora fin es requerido');
  static requiredForma= value => (value ? undefined : 'Formato para el conteo regresivo es obligatorio');

  static notrequired = value => (value ? undefined : undefined);

  static required = value => (value ? undefined : 'Este campo es requerido');

  static notNull = value => (value === 'null' || value === null ? 'Este campo es requerido' : undefined);

  static notDefault = value => (value === 'default' ? 'Este campo es requerido' : undefined);

  static number = value => value && isNaN(Number(value)) ? 'El campo tiene que ser  númerico' : undefined;

  static fileExtension = async (file) => {
    const fileName = file.name.toLowerCase();

    if (!fileName.endsWith('.png')) {
      throw new Error('El archivo debe tener la extensión ".png".');
    }

    try {
      const esValido = await esPNGValido(file);

      if (!esValido) {
        throw new Error('El archivo no es un PNG válido.');
      }
    } catch (error) {
      throw new Error(error.message);
    }
  };

  static minMoneyValue = min => value => {
    //const valorMoney = value ?  : 0;
    return value && parseInt(value.replace(/[^\d]/g, '')) < min ?
      `El valor ingresado debe ser mayor o igual a $${formatMoney(min, 0, 3, '.', ',')}` :
      (!value ? 'Este campo es requerido' : undefined);
  }

  static maxMoneyValue = max => value => {
    //const valorMoney = value ?  : 0;
    return value && parseInt(value.replace(/[^\d]/g, '')) > max ?
      `El valor ingresado debe ser menor o igual a $${formatMoney(max, 0, 3, '.', ',')}` : undefined;
  }

  static minLength3 = value =>
    minLength(3, value);

  static minLength4 = value =>
    minLength(4, value);

  static minLength5 = value =>
    minLength(5, value);

  static minLength6 = value =>
    minLength(6, value);

  static maxLength15 = value =>
    maxLength(15, value);

  static maxLength20 = value =>
    maxLength(20, value);

  static maxLength25 = value =>
    maxLength(25, value);

  static maxLength30 = value =>
    maxLength(30, value);

  static maxLength50 = value =>
    maxLength(50, value);

  static maxLength80 = value =>
    maxLength(80, value);

  static maxLength100 = value =>
    maxLength(100, value);
  static maxLengthContadorforma = value => maxLengthContadorforma(100, value);
  static maxLengthContadordes = value => maxLengthContadordes(100, value);
  static maxLengthContadorbton = value => maxLengthContadorbton(50, value);
  static maxLengthContadorurl = value => maxLengthContadorurl(50, value);

  static maxLength150 = value =>
    maxLength(150, value);

  static isNumber = value =>
    value && isNaN(Number(value)) ? 'El campo debe ser un número' : undefined;

  static email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? 'Debes ingresar un correo electrónico valido'
      : undefined;

  static isdate = value =>
    value && new Date(value) instanceof Date ? undefined : 'Debe ser una fecha valida';

  static telephoneNumber = value =>
    value && !/^(0|[1-9][0-9]{6})$/i.test(value)
      ? 'El número de teléfono debe tener 7 dígitos'
      : undefined;

  static phoneNumber = value =>{
    const newValue = value.replace(/[^\d]/g, '');
    return (
      newValue && !/^(0|[1-9][0-9]{9})$/i.test(newValue)
        ? 'El número de celular debe tener 10 dígitos'
        : undefined
    );
  }
  static fechaFinalMayorQueInicio = (fecha_hora_final, allValues) => {
    const fecha_hora_inicio = allValues.fecha_hora_inicio;

    if (fecha_hora_inicio && fecha_hora_final) {
      const fechaInicio = new Date(fecha_hora_inicio);
      const fechaFinal = new Date(fecha_hora_final);

      if (fechaFinal < fechaInicio) {
        return 'La fecha final no puede ser menor a la fecha de inicio.';
      }
    }
    return undefined; // Si la validación pasa, no se genera ningún error
  };
  static noImagesInText = value => {
    const regex = /<img[^>]*>/i; // Expresión regular que busca etiquetas <img>
    if (value && regex.test(value)) {
      return 'El contenido no puede contener imágenes.';
    }
    return undefined;
  };
}

export default Validators;
